export const BRAND_NAME = 'Hypex';
export const BRAND_DOMAIN = 'hypex.one';
export const PROVIDER_ID = 'BetFair';
export const BACKEND_DOMAIN = 'newhyp2025.co';
